import React from 'react';
import {goEducateLogo} from '../images';

const GoEducateLogo = ({className, height, width, onClick}) => (
  <img className="logo" src={goEducateLogo} alt="GoEducate-logo" />
);
export default GoEducateLogo;
